import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { message } from 'antd';
import { add, list, remove } from 'actions';
import { getAddedTags, getRemovedTags } from 'selectors/tag.selectors';

const mapStateToProps = state => ({
  themes: state.api.themes.data.results,
  itemTags: state.api.itemTags.data.results
});
const mapDispatchToProps = dispatch => ({
  loadTheme(themeModel) {
    return dispatch(list(
      REDUCER_KEY.themes.key,
      {
        page: 0,
        pageSize: 1,
        filters: [{
          id: 'model',
          value: themeModel
        }],
        sorted: []
      }
    ));
  },
  addTags(data) {
    const { tags } = data;
    return !tags.length ? Promise.resolve() : dispatch(add(REDUCER_KEY.itemTags.key, data));
  },
  removeTags(data) {
    const { tags } = data;
    return !tags.length ? Promise.resolve() : dispatch(remove(REDUCER_KEY.itemTags.key, data));
  }
});

const getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';

const AddTagsWrapper = (WrappedComponent) => {
  const HOC = (props) => {
    const {
      addTags, removeTags, dispatch, loadTheme, itemTags, ...rest
    } = props; // grab dispatch so as to not pass on
    /**
     * @description Process the adding and removing of Tags
     * @param {objectId} number
     * @param {tags} array
     * @param {originalTags} array
     * @return Promise
     */
    const processTags = (themeModel, objectId, tags, originalTags, versionId) => loadTheme(themeModel)
      .then((response) => {
        const themeId = response.results[0].id;
        const newTags = getAddedTags(tags, originalTags, themeId, objectId);
        const removedTags = getRemovedTags(tags, originalTags, itemTags);
        return removeTags({
          tags: removedTags,
          versionId
        })
          .then(
            removed => addTags({
              tags: newTags,
              versionId
            })
              .then(addResponse => addResponse || removed)
              .catch(
                (error) => {
                  message.error(error.allErrors);
                }
              )
          )
          .catch(
            error => message.error(error.allErrors)
          );
      });
    return (
      <WrappedComponent onProcessTags={processTags} {...rest} />
    );
  };

  HOC.propTypes = {
    dispatch: PropTypes.func,
    addTags: PropTypes.func,
    themes: PropTypes.array,
    itemTags: PropTypes.array,
    removeTags: PropTypes.func,
    loadTheme: PropTypes.func
  };

  HOC.defaultProps = {
    dispatch() {
    },
    addTags() {
    },
    themes: [],
    itemTags: [],
    removeTags() {
    },
    loadTheme() {
    }
  };

  HOC.displayName = getDisplayName(WrappedComponent);

  return HOC;
};

const AddTags = compose(connect(mapStateToProps, mapDispatchToProps), AddTagsWrapper);

export default AddTags;
